import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="status_page">
            <div className="status_icon"><Compass size="32" /></div>
            <span className="status_code">404 · Not Found</span>
            <h1>This page doesn't exist</h1>
            <p>The page you're looking for was moved, renamed, or never existed.</p>
            <button className="pill_button" onClick={() => navigate("/")}>Back to Dashboard</button>
        </div>
    )
}

export default NotFound;
